<template>
    <div class="home">
        <Header></Header>

        <div class="banner-rotativo my-4">
            <div class="container">
                <div class="row " v-if="lstVideos != null">
                    <div class="col-12">
                        <CarouselVideos :lstVideos="lstVideos"></CarouselVideos>
                    </div>
                </div>
            </div>
        </div>

        <!-- TOP -->
        <div class="box-principal">
            <div class="container">

                <div class="row px-3" v-if="lstNoticias.length > 0">
                    <div class="col-12 col-md-12 col-xl-6 px-0 mb-3" v-if="lstNoticias[0]">
                        <div class="thumb-noticia-capa">
                            <router-link :to="{name:'Noticia', params:{id:lstNoticias[0].idNoticia.toString(),n:formatLink(lstNoticias[0].dsTitulo)}}">
                                <div class="img-noticia-capa h-100 w-100 zoom" :style="'background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%), url('+lstNoticias[0].urlImagemInterna+');' ">
                                </div>
                                <div class="txt-noticia-capa">
                                    <span class="txt-p txt-size-14 txt-w-8 bg-colors-1 txt-white px-2 py-1 rounded">
                                        {{lstNoticias[0].nmSubCategoria}}
                                    </span>
                                    <p class="txt-h-5 txt-size-18 txt-white mt-3 mb-2 reduz-texto-3">
                                        {{lstNoticias[0].dsTitulo}}
                                    </p>
                                    <p class="txt-h-6 txt-size-12 txt-white txt-w-4 mb-2 reduz-texto-2">
                                        {{lstNoticias[0].dsSubTitulo}}
                                    </p>
                                    <p class="txt-h-6 txt-size-12 txt-white mb-0">
                                        {{formatDate(lstNoticias[0].dtPublicacao)}}
                                    </p>
                                </div>
                            </router-link>
                        </div>

                    </div>
                    <div class="col-12 col-md-12 col-xl-6 px-0">
                        <div class="d-flex w-100 flex-wrap">
                            <div class="col-12 col-md-6 pl-0 pl-lg-0 pl-xl-3 pr-0 " v-for="(item,index) in lstNoticias.slice(1)" :key="index" style="margin-bottom: 20px;">
                                <div class="thumb-noticia-p">
                                    <router-link :to="{name:'Noticia', params:{id:item.idNoticia.toString(),n:formatLink(item.dsTitulo)}}">
                                        <div class="img-noticia-p h-100 w-100 zoom" :style="'background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%), url('+item.urlImagemInterna+');'">
                                        </div>
                                        <div class="txt-noticia-capa">
                                            <span class="txt-p txt-size-12 txt-w-8 bg-blue-2 txt-white px-2 py-1 rounded">
                                                {{item.nmSubCategoria}}
                                            </span>
                                            <p class="txt-h-5 txt-size-14 txt-white my-1 reduz-texto-1">
                                                {{item.dsTitulo}}
                                            </p>
                                            <p class="txt-h-6 txt-size-12 txt-white txt-w-4 mb-0 reduz-texto-2">
                                                {{item.dsSubTitulo}}
                                            </p>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- PRINCIPAIS -->
        <div class="mt-4">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-9">
                        <Divisor :title="'Principais notícias'">
                            <template slot="verMais">
                                <router-link :to="{name:'PesquisaNoticia'}" class="txt-p txt-size-15 txt-cores-1">
                                    Ver mais notícias <i class="fas fa-chevron-right"></i>
                                </router-link>
                            </template>
                        </Divisor>

                        <div class="row mt-3">
                            <div class="col-6 col-lg-4 mb-4" v-for="item in lstNoticiasDestaque" :key="item.idNoticia">
                                <router-link :to="{name:'Noticia', params:{id:item.idNoticia.toString(),n:formatLink(item.dsTitulo)}}">
                                    <img class="w-100 zoom" :src="item.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                    <p class="txt-h-6 txt-size-12 txt-grey-2 mt-2 mb-1 d-flex align-items-center flex-wrap">
                                        <span class="txt-p txt-size-12 txt-w-8 bg-blue-2 txt-white px-2 py-1 rounded me-3">{{item.nmSubCategoria}}</span>
                                        <span>{{formatDate(item.dtPublicacao)}}</span>
                                    </p>
                                    <p class="txt-p txt-size-14 txt-w-8 txt-blue-2 mb-1 reduz-texto-2">
                                        {{item.dsTitulo}}
                                    </p>
                                    <p class="txt-p txt-size-12 txt-w-6 txt-grey-2 mb-0 reduz-texto-3">
                                        {{item.dsSubTitulo}}
                                    </p>
                                </router-link>

                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <Banner class="mb-4" :tipo="'Lateral'"></Banner>
                    </div>

                </div>
            </div>
        </div>

        <!-- TEMAS EM ALTA -->
        <div class="mt-4">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <Tags :titulo="'TEMAS EM ALTA'" :lstTags="lstTemasEmAlta" :link="'PesquisaNoticia'"></Tags>
                    </div>
                </div>
            </div>
        </div>

        <!-- BANNERS -->
        <div class="mt-4">
            <div class="container">

                <div class="row">
                    <div class="col-12">
                        <BannerOrientacoes></BannerOrientacoes>
                    </div>
                </div>
                <Banner class="mt-3 mb-4" :tipo="'Horizontal'"></Banner>
            </div>
        </div>

        <!-- AO VIVO -->
        <div class="mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="box-ao-vivo">
                            <div class="titulo-ao-vivo d-flex align-items-center">
                                <span class="txt-h-3 txt-size-24 txt-blue-2">
                                    Sollicita
                                </span>
                                <div class="bg-colors-2 ms-2 p-2 w-100">
                                    <span class="txt-h-3 txt-size-24 txt-white marcador-ao-vivo-branco d-flex align-items-center">
                                        AO VIVO
                                    </span>
                                </div>
                            </div>
                            <div class="conteudo-ao-vivo mt-4" v-if="aovivo != null">
                                <router-link :to="{name:'AoVivo'}">
                                    <div class="row">
                                        <div class="col-12 col-md-8" v-if="aovivo.urlImgFoto">
                                            <img class="w-100" :src="aovivo.urlImgFoto" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <span class="txt-h-5 txt-blue-2 marcador-ao-vivo-vermelho">AO VIVO</span>
                                            <p class="txt-h-2 txt-size-25 txt-blue-2">{{aovivo.nmEvento}}</p>
                                            <!--<p class="txt-h-4 txt-grey-2">{{aovivo.dsDescricao}}</p>-->

                                        </div>
                                    </div>
                                </router-link>
                            </div>
                            <div class="conteudo-ao-vivo-off d-flex flex-column align-items-center mt-3" v-else>
                                <span class="txt-h-3 txt-size-25 txt-blue-2">
                                    Não está acontecendo uma transmissão ao vivo no momento.
                                </span>
                                <p class="txt-h-4 txt-size-18 txt-blue-2 text-center mt-3 mb-0">
                                    Quando uma transmissão estiver ocorrendo,
                                </p>
                                <p class="txt-h-4 txt-size-18 txt-blue-2 text-center">
                                    você poderá saber checando este ícone <span class="marcador-ao-vivo-vermelho rounded bg-blue-2 txt-white p-2">AO VIVO</span> no menu principal.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- ARTIGOS -->
        <div class="mt-4">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8">
                        <Divisor :icon="'fas fa-file-alt'" :title="'ARTIGOS'" :verMais="true" :txtVerMais="'Ver mais notícias'" :linkVerMais="'PesquisaNoticia'">
                            <template slot="verMais">
                                <router-link :to="{name:'PesquisaNoticia', query:{idCategoria:idCategoriaArtigo}}" class="txt-p txt-size-15 txt-cores-1">
                                    Ver mais artigos <i class="fas fa-chevron-right"></i>
                                </router-link>
                            </template>
                        </Divisor>

                        <router-link :to="{name:'Noticia', params:{id:artigoDestaque.idNoticia.toString(),n:formatLink(artigoDestaque.dsTitulo)}}" class="row artigo-principal mt-3" v-if="artigoDestaque">
                            <div class="col-12 col-md-7">
                                <img class="w-100 zoom" style="max-height: 372px;" :src="artigoDestaque.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                            </div>
                            <div class="col-12 col-md-5">
                                <p class="txt-h-6 txt-size-12 txt-grey-2 mb-2">
                                    {{formatDate(artigoDestaque.dtPublicacao)}}
                                </p>
                                <div class="mb-2">
                                    <span class="txt-h-6 txt-size-14 bg-colors-1 txt-white px-2 py-1 rounded">
                                        {{artigoDestaque.nmSubCategoria}}
                                    </span>
                                </div>
                                <p class="txt-h-6 txt-size-20 txt-blue-2 mb-2 reduz-texto-3">
                                    {{artigoDestaque.dsTitulo}}
                                </p>
                                <p class="txt-p txt-w-6 txt-size-18 txt-grey-2 mb-0 reduz-texto-4">
                                    {{artigoDestaque.dsSubTitulo}}
                                </p>
                            </div>
                        </router-link>
                        <div class="row artigos mt-3">
                            <div class="col-6 col-md-4 artigo mb-4" v-for="(item) in lstArtigos" :key="item.idNoticia">
                                <router-link :to="{name:'Noticia', params:{id:item.idNoticia.toString(),n:formatLink(item.dsTitulo)}}">
                                    <img class="w-100 zoom" :src="item.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />

                                    <p class="txt-h-6 txt-size-12 txt-grey-2 mt-2 mb-1 d-flex align-items-center flex-wrap">
                                        <span class="txt-p txt-size-12 txt-w-8 bg-blue-2 txt-white px-2 py-1 rounded me-3">{{item.nmSubCategoria}}</span>
                                        <span>{{formatDate(item.dtPublicacao)}}</span>
                                    </p>

                                    <p class="txt-h-4 txt-size-14 txt-blue-2 mb-2 reduz-texto-2">
                                        {{item.dsTitulo}}
                                    </p>
                                    <p class="txt-p txt-size-12 txt-w-6 txt-grey-2 mb-0 reduz-texto-4">
                                        {{item.dsSubTitulo}}
                                    </p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <!-- MAIS LIDOS -->
                    <div class="col-12 col-md-4 mt-3 mt-sm-0">
                        <Divisor :icon="'fas fa-desktop'" :title="'MAIS LIDOS'">
                            <template slot="verMais">
                                <router-link :to="{name:'PesquisaNoticia'}" class="txt-p txt-size-15 txt-cores-1">
                                    Ver mais notícias <i class="fas fa-chevron-right"></i>
                                </router-link>
                            </template>
                        </Divisor>

                        <div class="artigos-mais-lidos mt-3">
                            <div class="row mb-4" v-for="(item,index) in lstNoticiasMaisLidas" :key="index">
                                <router-link :to="{name:'Noticia', params:{id:item.idNoticia.toString(),n:formatLink(item.dsTitulo)}}" class="d-flex">
                                    <div class="col-12 ">
                                        <div class="d-flex align-items-center">
                                            <span :class="'txt-p txt-size-26 txt-w-4 me-3 txt-italic '+(index == 0?'txt-cores-1 ':'txt-grey-2')">{{index+1}}</span>
                                            <span class="txt-h-5 txt-w-7 txt-size-18 txt-blue-2">{{item.dsTitulo}}</span>
                                        </div>

                                    </div>
                                    <!--<div class="col-5 d-flex justify-content-end">
                                    <img class="w-100 zoom" style="max-height: 100px;" :src="item.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                </div>-->
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="my-4 mb-5">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <Divisor :icon="'fas fa-video'" :title="'VÍDEOS'">
                            <template slot="verMais">
                                <router-link :to="{name:'PesquisaVideo', params:{}}" class="txt-p txt-size-15 txt-cores-1">
                                    Ver mais vídeos <i class="fas fa-chevron-right"></i>
                                </router-link>
                            </template>
                        </Divisor>

                        <GridVideos class="mt-3" :lstVideos="lstVideos"></GridVideos>
                    </div>
                </div>
            </div>

        </div>

        <Footer></Footer>

    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Divisor from '@/components/Divisor'
    import GridVideos from '@/components/GridVideos'
    import CarouselVideos from '@/components/CarouselVideos'
    import Tags from '@/components/Tags'
    import BannerOrientacoes from '@/components/BannerOrientacoes'
    import Banner from '@/components/Banner'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Home',
        components: { Header, Footer, GridVideos, CarouselVideos, Tags, BannerOrientacoes, Banner, Divisor},
        computed: {
            user() {
                return this.$store.state.user
            },
            aovivo() {
                return this.$store.state.aovivo
            },
        },
        data: function () {
            return {
                idCategoriaArtigo: 40,

                lstNoticias: [],

                lstNoticiasDestaque: [],
                lstTemasEmAlta: [],
                artigoDestaque: null,
                lstArtigos: [],
                lstNoticiasMaisLidas: [],
                lstVideos: [],

                metaTags: {
                    title: "Sollicita",
                    meta: [
                        { name: 'description', content: 'O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.' },
                        { name: 'keywords', content: 'Notícias, Licitações, Contratos, Administração, Portal, Plataforma, Conteúdo, Sollicita, Vídeos, Pública, Administração' },

                        { itemprop: 'name', content: 'Sollicita - A ferramenta completa para licitações e contratos' },
                        { itemprop: 'description', content: 'O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.' },
                        { itemprop: 'image', content: window.location.origin + '114px_rounded.png' },

                        { name: 'twitter:card', content: 'summary' },
                        { name: 'twitter:site', content: '@gruponp' },
                        { name: 'twitter:title', content: 'Sollicita - A ferramenta completa para licitações e contratos' },
                        { name: 'twitter:description', content: 'O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.' },
                        { name: 'twitter:creator', content: '@gruponp' },
                        { name: 'twitter:image', content: window.location.origin + '114px_rounded.png' },

                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:title', content: 'Sollicita - A ferramenta completa para licitações e contratos' },
                        { property: 'og:url', content: window.location.href },
                        { property: 'og:image', content: window.location.origin + '114px_rounded.png' },
                        { property: 'og:image:secure_url', content: window.location.origin + '114px_rounded.png' },
                        { property: 'og:image:type', content: 'image/png' },
                        { property: 'og:description', content: 'O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.' },
                        { property: 'og:site_name', content: 'Sollicita' },
                        { property: 'og:image:width', content: '300' },
                        { property: 'og:image:height', content: '200' },
                        { property: 'fb:admins', content: 'sollicita' },
                        { property: 'og:type', content: 'website' },

                        { name: 'application-name', content: 'Sollicita' },
                        { name: 'theme-color', content: '#2d5289' },
                        { name: 'msapplication-TileColor', content: '#2d5289' },
                        { name: 'msapplication-TileImage', content: window.location.origin + '114px_rounded.png' },
                    ]
                },
            }
        },
        metaInfo() {
            return this.metaTags
        },
        methods: {
            load() {
                this.carregaNoticias();
                this.carregaNoticiasDestaque();
                this.carregaTemasEmAlta();
                this.carregaArtigoDestaque();
                this.carregaArtigos();
                this.carregaMaisLidas();
                this.carregaVideos();

            },
            
            carregaNoticias() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get`, { params: { take: 5, index: 0, isNoticiaPrincipal: true  } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstNoticias = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let noticia = res.data.data.rows[i];
                                    noticia.urlImagem = $this.getUrlS3(noticia.urlImagem);
                                    noticia.urlImagemInterna = $this.getUrlS3(noticia.urlImagemInterna);

                                    $this.lstNoticias.push(noticia);
                                }

                            }
                        } else {
                            avisoErro("Não foi possível carregar as notícias");
                            $this.lstNoticias = [];
                        }
                    })
                    .catch(function(){
                        avisoErro("Não foi possível carregar as notícias");
                        $this.lstNoticias = [];
                    });
            },

            carregaNoticiasDestaque() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get`, { params: { take: 6, index: 0, isNoticiaPrincipal: false } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstNoticiasDestaque = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let noticia = res.data.data.rows[i];
                                    noticia.urlImagem = $this.getUrlS3(noticia.urlImagem);
                                    noticia.urlImagemInterna = $this.getUrlS3(noticia.urlImagemInterna);
                                    $this.lstNoticiasDestaque.push(noticia);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar as notícias");
                            $this.lstNoticiasDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar as notícias");
                        $this.lstNoticiasDestaque = null;
                    });
            },

            carregaTemasEmAlta() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/TemasEmAlta`, { params: { take: 6 } })
                    .then(res => {
                        if (res.data.success) {                            
                            $this.lstTemasEmAlta = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let noticia = res.data.data.rows[i];
                                    
                                    $this.lstTemasEmAlta.push(noticia);
                                }
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar os temas em alta");
                            $this.lstTemasEmAlta = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os temas em alta");
                        $this.lstTemasEmAlta = null;
                    });
            },

            carregaArtigoDestaque() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get`, { params: { take: 1, index: 0, isNoticiaPrincipal: true , nmSubCategoria: "Artigo" } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let artigo = res.data.data.rows[i];
                                    artigo.urlImagem = $this.getUrlS3(artigo.urlImagem);
                                    artigo.urlImagemInterna = $this.getUrlS3(artigo.urlImagemInterna);
                                    $this.artigoDestaque = artigo;
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os artigos");
                            $this.artigoDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os artigos");
                        $this.artigoDestaque = null;
                    });
            },

            carregaArtigos() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get`, { params: { take: 6, index: 0, isNoticiaPrincipal: false, nmSubCategoria: "Artigo" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstArtigos = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let artigo = res.data.data.rows[i];
                                    artigo.urlImagem = $this.getUrlS3(artigo.urlImagem);
                                    artigo.urlImagemInterna = $this.getUrlS3(artigo.urlImagemInterna);
                                    $this.lstArtigos.push(artigo);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os artigos");
                            $this.lstArtigos = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os artigos");
                        $this.lstArtigos = null;
                    });
            },

            carregaMaisLidas() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/MaisLidas`, { params: { take: 15, index: 0 } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstNoticiasMaisLidas = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let artigo = res.data.data.rows[i];
                                    //artigo.urlImagem = $this.getUrlS3(artigo.urlImagem);
                                    //artigo.urlImagemInterna = $this.getUrlS3(artigo.urlImagemInterna);
                                    $this.lstNoticiasMaisLidas.push(artigo);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar mais lidos ");
                            $this.lstNoticiasMaisLidas = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar mais lidos ");
                        $this.lstNoticiasMaisLidas = null;
                    });
            },

            carregaVideos() {
                let $this = this;
                axios.get(`${urlApi}/Video/Get`, { params: { take: 5, index: 0 } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstVideos = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstVideos.push({
                                        id: item.idVideo,
                                        titulo: item.nmTitulo,
                                        descricao: item.dsDescricao,
                                        img: item.urlImagem,
                                        categoria: item.categoria.nmCategoria,
                                    });
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os vídeos");
                            $this.lstVideos = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os vídeos");
                        $this.lstVideos = null;
                    });
            },


            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }

            },

            formatDate(date) {
                if (date) {
                    return moment(date).format('DD/MM/YYYY [às] HH:mm');
                } else {
                    return "";
                }
            },

            getUrlS3(url) {
                return `${urlApi}/Utilidade/GetUrlS3?url=${url}`;
            },

        },
        mounted: function () {
            let $this = this;
            $this.load();

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .box-principal{
       
    }

    .thumb-noticia-capa {
        display: block;
        overflow: hidden;
        position: relative;
        height: 400px;
        box-sizing: border-box;
        padding: 0;
        background-color: transparent;

        .img-noticia-capa {
            background-position: center !important;
            background-size: cover !important;
        }

        .txt-noticia-capa {
            z-index: 100;
            text-align: left;
            position: absolute;
            right: 0;
            left: 0;
            padding: 0 20px;
            bottom: 20px;
            top: auto;
        }
    }

    .thumb-noticia-p {
        display: block;
        overflow: hidden;
        position: relative;
        height: 190px;
        box-sizing: border-box;
        padding: 0;
        background-color: transparent;

        .img-noticia-p {
            background-position: center !important;
            background-size: cover !important;
        }

        .txt-noticia-capa {
            z-index: 100;
            text-align: left;
            position: absolute;
            right: 0;
            left: 0;
            padding: 0 10px;
            bottom: 10px;
            top: auto;
        }
    }

    .box-ao-vivo, .box-ao-vivo-off {
        .titulo-ao-vivo {
            .marcador-ao-vivo-branco::after {
                content: "\A";
                width: 15px;
                height: 15px;
                border-radius: 50%;
                background: color('colors','2');
                display: inline-block;
                margin: 0 10px;
                border: 4px solid #FFF;
                filter: blur(0.5px);
            }
        }

        .conteudo-ao-vivo {
            background: color('grey','3');
            box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
            padding: 40px;
        }

        .conteudo-ao-vivo-off {
            p {
                line-height: 35px;
            }
        }

        .marcador-ao-vivo-vermelho::after {
            content: "\A";
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: color('colors','2');
            display: inline-block;
            margin: 0 5px;
            filter: blur(1px);
        }
    }

</style>

